import { render, staticRenderFns } from "./productManagementDetails.vue?vue&type=template&id=1720800f&scoped=true&"
import script from "./productManagementDetails.vue?vue&type=script&lang=js&"
export * from "./productManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./productManagementDetails.vue?vue&type=style&index=0&id=1720800f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1720800f",
  null
  
)

export default component.exports